module.exports = __webpack_public_path__ + "static/img/cont42_02.8651077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont42_02.png
// module id = CQT8
// module chunks = 0